import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import TripDetails from '@/components/trip-details';

export default function TripDetailsScreen() {
  const { styles } = useStyles(stylesheet);
  const { id } = useLocalSearchParams();

  return (
    <View style={styles.container}>
      <TripDetails id={id} />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
